/**
 * Вопросы узнавания по голосу для рельса «Участники».
 *
 * Сервис отдаёт две разные вещи, и путать их нельзя:
 *  - `speaker_names` — узнали, имя уже подставлено в расшифровку; спрашиваем
 *    «это он?», чтобы человек подтвердил или поправил;
 *  - `speaker_suggestions` — предположение с оценкой похожести; имя НЕ
 *    подставлено, вопрос осторожнее: «возможно, это он».
 *
 * Ответы человека живут снаружи (`answers`): подтверждённое и отклонённое
 * повторно не спрашиваем — иначе один и тот же вопрос всплывает после каждого
 * ответа.
 */

/** «SPEAKER_03» → «УЧАСТНИК_4»: человек считает с единицы. */
function labelOf(speakerId) {
  const number = parseInt(String(speakerId || '').split('_')[1], 10) || 0;
  return `УЧАСТНИК_${number + 1}`;
}

export function voiceQuestions(status, answers = {}) {
  const recognized = Object.entries((status && status.speaker_names) || {})
    .map(([speakerId, name]) => ({ speakerId, name, kind: 'recognized', label: labelOf(speakerId) }));

  const suggested = Object.entries((status && status.speaker_suggestions) || {})
    .map(([speakerId, item]) => ({
      speakerId,
      name: item && item.name,
      score: item && item.score,
      kind: 'suggested',
      label: labelOf(speakerId),
    }));

  return [...recognized, ...suggested]
    .filter((item) => item.name)
    .filter((item) => !answers[item.speakerId]);
}
